import { getDropdownMetric } from "../actions/mygoal";
import RestService from "./rest.service";

class scalingMaster {
  getListScalingMaster() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpiscale`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createScalingMaster(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpiscale`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEditScalingMaster(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpiscale/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editScalingMaster(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpiscale/${serial}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteScalingMaster(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpiscale/${id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getDropdownType() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpiscale/dropdown/type`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new scalingMaster();
